/* ============================================================================
   c111-render-config.js  ·  111 Cientonce
   ÚNICO archivo que hay que tocar para calibrar el personalizador.
   ---------------------------------------------------------------------------
   TRIATLÓN (decisión del 14 ago 2026)
   Hay UN SOLO par de renders estándar por tipo de manga. No uno por referencia.

     MANGA CORTA -> cortaF (frente) + cortaE (espalda)
     MANGA SISA   -> sisaF  (frente) + sisaE  (espalda)

   Aero, racer, sprinter y élite comparten el mismo par. Lo único que cambia
   entre referencias son los colores, y el render es blanco a propósito: es una
   prenda de referencia para ubicar el aplique, no el producto del cliente.
   Lo que SÍ tiene que coincidir es la manga, porque el cliente aprueba sobre
   esa silueta (en el pedido #13614 aprobó sobre una manga sisa sin serlo).
   ---------------------------------------------------------------------------
   RUNNING (26 ago 2026) — mismas reglas, ver el bloque de abajo.
   ---------------------------------------------------------------------------
   LOS TRES NÚMEROS QUE MÁS SE TOCAN
   · ANCHO_DEFECTO : con cuántos cm arranca un aplique nuevo
   · el último número de cada Z(...) : ancho MÁXIMO en cm de esa zona
   · PECHO_CM : si TODO se ve grande o pequeño en TRIATLÓN, es este.
     En running cada vista lleva su propia medida en cm (vistaCm).
   ---------------------------------------------------------------------------
   CAMBIAR UN RENDER ESTÁNDAR
   1. Súbelo a Shopify > Contenido > Archivos y copia la URL.
      TIENE QUE SER DE FRENTE PLANO, no en 3/4 ni de lado: sobre una prenda
      girada el cliente no puede ubicar bien el aplique.
   2. Reemplaza la URL en IMG (triatlón) o IMGR (running).
   3. Recalibra su vista.
   ---------------------------------------------------------------------------
   El máximo real nunca pasa del ancho de la zona: si pides 20 cm en una zona
   que solo da 17,5 el sistema deja 17,5. Nunca deja el aplique fuera de tela.
   ========================================================================== */
(function(){
'use strict';

var ANCHO_DEFECTO = 12;   /* con cuántos cm de ancho arranca un aplique nuevo */
var PECHO_CM = 36;        /* triatlón: ancho de la prenda plana donde empieza el short, talla M */

var IMG = {
  /* --- estándar manga corta --- */
  cortaF   : 'https://cdn.shopify.com/s/files/1/0254/8665/5591/files/traje_aero_frente.jpg?v=1786636661',
  cortaE   : 'https://cdn.shopify.com/s/files/1/0254/8665/5591/files/Render_espalda_manga_corta.jpg?v=1786714931',

  /* --- estándar manga sisa --- */
  sisaF    : 'https://cdn.shopify.com/s/files/1/0254/8665/5591/files/render_sprinter_manga_sisa_frente.jpg?v=1786636661',
  sisaE    : 'https://cdn.shopify.com/s/files/1/0254/8665/5591/files/traje_racer_manga_sisa_espalda.jpg?v=1786636661'

  /* --- fuera de uso, quedan anotados por si alguna vez sirven ---
     racer frente    : .../traje_racer_frente.jpg
       Es frente plano y sirve, pero la prenda queda más chica en el cuadro que
       la de aero. Se dejó la de aero como estándar.
     sprinter frente : .../render_sprinter_frente.jpg
       NO SIRVE: está en 3/4, la prenda está girada. Sobre una prenda de lado el
       cliente no puede ubicar el aplique ni juzgar el tamaño. Si alguien la
       vuelve a conectar, el error del #13614 se repite en otra forma.
  */
};

function vista(img, ratio, anchoFrac, zoom, zonas, zip){
  return { img:img, ratio:ratio, zoom:zoom,
           frameCm:+(PECHO_CM/anchoFrac).toFixed(0), zonas:zonas, zip:zip||null };
}
/* igual que vista(), pero con la medida real de ESA prenda en cm.
   En running cada familia tiene su propio pecho, así que no sirve un solo
   PECHO_CM global. */
function vistaCm(img, ratio, anchoFrac, prendaCm, zoom, zonas){
  return { img:img, ratio:ratio, zoom:zoom||1,
           frameCm:+(prendaCm/anchoFrac).toFixed(0), zonas:zonas, zip:null };
}
var Z = function(k,l,x1,y1,x2,y2,cap){ return {k:k,l:l,x1:x1,y1:y1,x2:x2,y2:y2,cap:cap}; };

var V = {

  /* ---------- ESTÁNDAR MANGA CORTA ---------- */

  /* frente. Frente plano, prenda grande y centrada en el cuadro. */
  cortaF: vista(IMG.cortaF, 1.6, 0.494, 1.0, [
      Z('torso','Torso',            35,13,65,45,20),
      Z('musloD','Muslo derecho',   32,60,46,76,12),
      Z('musloI','Muslo izquierdo', 54,60,68,76,12)
    ], {x:50,y1:10,y2:49}),

  /* espalda (1309x1600). Medido: prenda de y=17 a y=83,3 ; en la cintura ocupa
     el 26,66% del ancho. En la espalda los lados se invierten: el muslo derecho
     de quien la usa queda a la derecha de la imagen. */
  cortaE: vista(IMG.cortaE, 1.2223, 0.2666, 1.1, [
      Z('espalda','Espalda',         43,24,57,46,24),
      Z('musloIB','Muslo izquierdo', 40,62,48,78,12),
      Z('musloDB','Muslo derecho',   52,62,60,78,12)
    ]),

  /* ---------- ESTÁNDAR MANGA SISA ---------- */

  sisaF: vista(IMG.sisaF, 1, 0.239, 1.35, [
      Z('torso','Torso',            41,14,59,43,20),
      Z('musloD','Muslo derecho',   38,58,48,74,12),
      Z('musloI','Muslo izquierdo', 52,58,62,74,12)
    ], {x:50,y1:12,y2:47}),

  /* el panel blanco de la espalda va de y=31 a y=45 */
  sisaE: vista(IMG.sisaE, 1, 0.2275, 1.35, [
      Z('espalda','Espalda',         42,31,58,45,24),
      Z('musloIB','Muslo izquierdo', 38,77,48,86,12),
      Z('musloDB','Muslo derecho',   52,77,62,86,12)
    ])
};

/* ==========================================================================
   RUNNING · 26 ago 2026
   --------------------------------------------------------------------------
   MISMA REGLA QUE TRIATLÓN: si el producto trae su propio render (metacampos
   custom.render_frente / custom.render_espalda) se usa ese. Si no, cae al
   render de referencia de su familia, y el aviso de arriba se lo dice.

   QUÉ ESTÁ AUTORIZADO HOY
   · Camisillas (tank): render genérico propio, hombre y mujer, en blanco,
     negro y gris, frente Y espalda. Doce archivos, todos 1000x1200, la prenda
     centrada al 80% del alto. Se armaron el 26 ago recortando y centrando los
     seis renders dobles que subió Nicolás (front y back venían en una sola
     imagen). El color se elige por el título del producto; si no dice nada,
     blanco.
   · Camisetas (tee): hay UN render de frente autorizado (racer brezza) y NO
     hay render de espalda. Por eso la camiseta va SOLO FRENTE: no se le pone
     la espalda de una camisilla, que es otra silueta. Cuando llegue el render
     de espalda de camiseta, se agrega aquí y la pestaña aparece sola.
   · Licras, pantalonetas y tops: NO hay render autorizado. Van solo con el
     render real del producto si algún día se lo cargan por metacampo, y
     siempre solo frente (run-abajo tiene back:null). Sin render real, el
     personalizador no aparece. Orden expresa de Nicolás: nada inventado.

   PENDIENTE (los archivos ya están en Shopify, falta medirlos y calibrarlos)
   · Crop top: croptopbrezzafrente + crop_top_brezza_espalda_2 (y el par manta).
   · Manga larga: camisamangalargafrenteshadow + camisa_manga_larga_espalda_shadow.
     No entraron hoy porque su ancho de pecho no se puede medir del render sin
     confundir el cuerpo con las mangas, y no hay medida oficial de esas dos
     familias en la guía de tallas.

   MEDIDAS REALES usadas (guía de tallas, prenda extendida, talla M, de sisa a
   sisa): camisilla hombre 52 cm · camisilla mujer 40 cm · camiseta hombre
   51,5 cm · camiseta mujer 46,5 cm.
   ========================================================================== */

var R = 'https://cdn.shopify.com/s/files/1/0254/8665/5591/files/';
var IMGR = {
  tkHB_F : R+'run_tank_hombre_blanco_frente.png',
  tkHB_E : R+'run_tank_hombre_blanco_espalda.png',
  tkHN_F : R+'run_tank_hombre_negro_frente.png',
  tkHN_E : R+'run_tank_hombre_negro_espalda.png',
  tkHG_F : R+'run_tank_hombre_gris_frente.png',
  tkHG_E : R+'run_tank_hombre_gris_espalda.png',
  tkMB_F : R+'run_tank_mujer_blanco_frente.png',
  tkMB_E : R+'run_tank_mujer_blanco_espalda.png',
  tkMN_F : R+'run_tank_mujer_negro_frente.png',
  tkMN_E : R+'run_tank_mujer_negro_espalda.png',
  tkMG_F : R+'run_tank_mujer_gris_frente.png',
  tkMG_E : R+'run_tank_mujer_gris_espalda.png',
  teeF   : R+'teeracerbrezzafrente.png?v=1787689645'
};

/* zonas medidas sobre los renders finales (en % de la imagen).
   La silueta de la camisilla hombre va de x=27 a x=73 en el pecho; se dejan
   seis puntos de margen a cada lado para que el aplique nunca toque la sisa. */
var ZT_HF = [ Z('torso','Torso',     33,34,67,62,20) ];
var ZT_HE = [ Z('espalda','Espalda', 33,30,67,62,24) ];
var ZT_MF = [ Z('torso','Torso',     35,38,65,60,16) ];
var ZT_ME = [ Z('espalda','Espalda', 35,36,65,60,18) ];
var ZTEE  = [ Z('torso','Torso',     34,24,66,50,20) ];

/* el frente y la espalda de la misma prenda comparten frameCm a propósito:
   si no, un aplique de 12 cm se vería de distinto tamaño al cambiar de
   pestaña. Se usa la medida del frente para las dos. */
var VR = {
  tkHB_F: vistaCm(IMGR.tkHB_F, 1.2, 0.48, 52,   1, ZT_HF),
  tkHB_E: vistaCm(IMGR.tkHB_E, 1.2, 0.48, 52,   1, ZT_HE),
  tkHN_F: vistaCm(IMGR.tkHN_F, 1.2, 0.48, 52,   1, ZT_HF),
  tkHN_E: vistaCm(IMGR.tkHN_E, 1.2, 0.48, 52,   1, ZT_HE),
  tkHG_F: vistaCm(IMGR.tkHG_F, 1.2, 0.48, 52,   1, ZT_HF),
  tkHG_E: vistaCm(IMGR.tkHG_E, 1.2, 0.48, 52,   1, ZT_HE),
  tkMB_F: vistaCm(IMGR.tkMB_F, 1.2, 0.46, 40,   1, ZT_MF),
  tkMB_E: vistaCm(IMGR.tkMB_E, 1.2, 0.46, 40,   1, ZT_ME),
  tkMN_F: vistaCm(IMGR.tkMN_F, 1.2, 0.46, 40,   1, ZT_MF),
  tkMN_E: vistaCm(IMGR.tkMN_E, 1.2, 0.46, 40,   1, ZT_ME),
  tkMG_F: vistaCm(IMGR.tkMG_F, 1.2, 0.46, 40,   1, ZT_MF),
  tkMG_E: vistaCm(IMGR.tkMG_E, 1.2, 0.46, 40,   1, ZT_ME),
  teeH_F: vistaCm(IMGR.teeF,   1.2, 0.47, 51.5, 1, ZTEE),
  teeM_F: vistaCm(IMGR.teeF,   1.2, 0.47, 46.5, 1, ZTEE)
};

/* ==========================================================================
   Lo único que decide qué render ve el cliente es la MANGA de lo que compró.

   Si alguna referencia llegara a quedar sin render, se pone back:null o
   front:null y se le oculta esa pestaña. Nunca se le muestra al cliente una
   prenda que no corresponde a la que compró.
   ========================================================================== */
var RENDERS = {
  'aero'         : {front:V.cortaF, back:V.cortaE},
  'racer'        : {front:V.cortaF, back:V.cortaE},
  'sprinter'     : {front:V.cortaF, back:V.cortaE},
  'elite'        : {front:V.cortaF, back:V.cortaE},
  'aero-sisa'    : {front:V.sisaF,  back:V.sisaE},
  'racer-sisa'   : {front:V.sisaF,  back:V.sisaE},
  'sprinter-sisa': {front:V.sisaF,  back:V.sisaE},
  'elite-sisa'   : {front:V.sisaF,  back:V.sisaE},

  /* running */
  'run-tank-h'       : {front:VR.tkHB_F, back:VR.tkHB_E},
  'run-tank-h-negro' : {front:VR.tkHN_F, back:VR.tkHN_E},
  'run-tank-h-gris'  : {front:VR.tkHG_F, back:VR.tkHG_E},
  'run-tank-m'       : {front:VR.tkMB_F, back:VR.tkMB_E},
  'run-tank-m-negro' : {front:VR.tkMN_F, back:VR.tkMN_E},
  'run-tank-m-gris'  : {front:VR.tkMG_F, back:VR.tkMG_E},
  'run-tee-h'        : {front:VR.teeH_F, back:null},
  'run-tee-m'        : {front:VR.teeM_F, back:null},
  /* licras y pantalonetas: solo el render real del producto, solo frente */
  'run-abajo'        : {front:null, back:null}
};

/* atajos definidos EN RELACION a la zona, asi sirven en cualquier render.
   Los de espalda se ocultan solos si la referencia no tiene espalda. */
var SHORTCUTS_TRI = [
  {l:'Pecho derecho',  v:'front', r:'torso',   rx:.25, ry:.18},
  {l:'Pecho izquierdo',v:'front', r:'torso',   rx:.75, ry:.18},
  {l:'Centro pecho',   v:'front', r:'torso',   rx:.50, ry:.20},
  {l:'Muslo derecho',  v:'front', r:'musloD',  rx:.50, ry:.35},
  {l:'Muslo izquierdo',v:'front', r:'musloI',  rx:.50, ry:.35},
  {l:'Espalda alta',   v:'back',  r:'espalda', rx:.50, ry:.22},
  {l:'Espalda baja',   v:'back',  r:'espalda', rx:.50, ry:.72}
];

/* En running no hay muslos. El personalizador solo filtra los atajos por
   frente/espalda, no revisa si la zona existe, asi que un atajo de muslo en
   una camisilla apuntaria a una zona inexistente. Por eso la lista se arma
   segun la referencia que traiga la pagina. */
var SHORTCUTS_RUN = [
  {l:'Pecho derecho',  v:'front', r:'torso',   rx:.25, ry:.22},
  {l:'Pecho izquierdo',v:'front', r:'torso',   rx:.75, ry:.22},
  {l:'Centro pecho',   v:'front', r:'torso',   rx:.50, ry:.25},
  {l:'Espalda alta',   v:'back',  r:'espalda', rx:.50, ry:.20},
  {l:'Espalda baja',   v:'back',  r:'espalda', rx:.50, ry:.70}
];

var _n = document.getElementById('c111p');
var _ref = _n ? (_n.getAttribute('data-ref') || '') : '';
var SHORTCUTS = _ref.indexOf('run-') === 0 ? SHORTCUTS_RUN : SHORTCUTS_TRI;

var BANDERAS = {"COL": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect y='0' width='5' height='1.5' fill='%23FCD116'/><rect y='1.5' width='5' height='0.75' fill='%23003893'/><rect y='2.25' width='5' height='0.75' fill='%23CE1126'/></svg>", "MEX": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect x='0' width='1.66' height='3' fill='%23006847'/><rect x='1.66' width='1.66' height='3' fill='%23FFFFFF'/><rect x='3.33' width='1.66' height='3' fill='%23CE1126'/></svg>", "PER": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect x='0' width='1.66' height='3' fill='%23D91023'/><rect x='1.66' width='1.66' height='3' fill='%23FFFFFF'/><rect x='3.33' width='1.66' height='3' fill='%23D91023'/></svg>", "ECU": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect y='0' width='5' height='1.5' fill='%23FFDD00'/><rect y='1.5' width='5' height='0.75' fill='%230033A0'/><rect y='2.25' width='5' height='0.75' fill='%23EF3340'/></svg>", "ARG": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect y='0' width='5' height='1' fill='%2375AADB'/><rect y='1' width='5' height='1' fill='%23FFFFFF'/><rect y='2' width='5' height='1' fill='%2375AADB'/></svg>", "FRA": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect x='0' width='1.66' height='3' fill='%23002395'/><rect x='1.66' width='1.66' height='3' fill='%23FFFFFF'/><rect x='3.33' width='1.66' height='3' fill='%23ED2939'/></svg>", "ITA": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect x='0' width='1.66' height='3' fill='%23008C45'/><rect x='1.66' width='1.66' height='3' fill='%23F4F5F0'/><rect x='3.33' width='1.66' height='3' fill='%23CD212A'/></svg>", "DEU": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect y='0' width='5' height='1' fill='%23000000'/><rect y='1' width='5' height='1' fill='%23DD0000'/><rect y='2' width='5' height='1' fill='%23FFCE00'/></svg>", "ESP": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect y='0' width='5' height='0.75' fill='%23AA151B'/><rect y='0.75' width='5' height='1.5' fill='%23F1BF00'/><rect y='2.25' width='5' height='0.75' fill='%23AA151B'/></svg>", "PRT": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect width='5' height='3' fill='%23FF0000'/><rect width='2' height='3' fill='%23006600'/><circle cx='2' cy='1.5' r='0.62' fill='%23FFE800' stroke='%23FFF' stroke-width='0.06'/><circle cx='2' cy='1.5' r='0.36' fill='%23FFF'/><circle cx='2' cy='1.5' r='0.3' fill='%23DA291C'/></svg>", "CHL": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect width='5' height='3' fill='%23FFFFFF'/><rect y='1.5' width='5' height='1.5' fill='%23D52B1E'/><rect width='1.5' height='1.5' fill='%230039A6'/><path d='M.75 .42 .89 .84 1.33 .84 .97 1.10 1.11 1.52 .75 1.26 .39 1.52 .53 1.10 .17 .84 .61 .84Z' fill='%23FFF'/></svg>", "CRI": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect y='0' width='5' height='0.50' fill='%23002B7F'/><rect y='0.50' width='5' height='0.50' fill='%23FFFFFF'/><rect y='1.00' width='5' height='0.99' fill='%23CE1126'/><rect y='2.00' width='5' height='0.50' fill='%23FFFFFF'/><rect y='2.50' width='5' height='0.50' fill='%23002B7F'/></svg>", "PAN": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect width='5' height='3' fill='%23FFFFFF'/><rect x='2.5' width='2.5' height='1.5' fill='%23D21034'/><rect y='1.5' width='2.5' height='1.5' fill='%23005293'/><path d='M1.25 .42 1.39 .84 1.83 .84 1.47 1.10 1.61 1.52 1.25 1.26 .89 1.52 1.03 1.10 .67 .84 1.11 .84Z' fill='%23005293'/><path d='M3.75 1.92 3.89 2.34 4.33 2.34 3.97 2.60 4.11 3.02 3.75 2.76 3.39 3.02 3.53 2.60 3.17 2.34 3.61 2.34Z' fill='%23D21034'/></svg>", "BRA": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect width='5' height='3' fill='%23009C3B'/><path d='M2.5 .28 4.72 1.5 2.5 2.72 .28 1.5Z' fill='%23FFDF00'/><circle cx='2.5' cy='1.5' r='0.62' fill='%23002776'/></svg>", "USA": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><defs><pattern id='st' width='5' height='0.4615' patternUnits='userSpaceOnUse'><rect width='5' height='0.2307' fill='%23B22234'/><rect y='0.2307' width='5' height='0.2308' fill='%23FFF'/></pattern><pattern id='sr' width='0.34' height='0.359' patternUnits='userSpaceOnUse'><circle cx='0.085' cy='0.09' r='0.052' fill='%23FFF'/><circle cx='0.255' cy='0.269' r='0.052' fill='%23FFF'/></pattern></defs><rect width='5' height='3' fill='url(%23st)'/><rect width='2' height='1.615' fill='%233C3B6E'/><rect width='2' height='1.615' fill='url(%23sr)'/></svg>", "GBR": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><rect width='5' height='3' fill='%23012169'/><path d='M0,0 L5,3 M5,0 L0,3' stroke='%23FFFFFF' stroke-width='0.62'/><path d='M0,0 L5,3 M5,0 L0,3' stroke='%23C8102E' stroke-width='0.3'/><path d='M2.5,0 V3 M0,1.5 H5' stroke='%23FFFFFF' stroke-width='1'/><path d='M2.5,0 V3 M0,1.5 H5' stroke='%23C8102E' stroke-width='0.6'/></svg>"};

window.C111render = { PECHO_CM:PECHO_CM, ANCHO_DEFECTO:ANCHO_DEFECTO, IMG:IMG, IMGR:IMGR, V:V, VR:VR,
                      RENDERS:RENDERS, SHORTCUTS:SHORTCUTS, BANDERAS:BANDERAS };
})();